import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/svg/time.svg'


import { formatDate, formatTime } from '@/utilities/dateformatter'



export default /*@__PURE__*/_defineComponent({
  __name: 'DateTimeCell',
  props: {
  timestamp: Date
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(_unref(formatDate)(__props.timestamp)) + " ", 1),
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      class: "ms-clock-icon",
      src: _imports_0
    }, null, -1)),
    _createTextVNode(" " + _toDisplayString(_unref(formatTime)(__props.timestamp)), 1)
  ], 64))
}
}

})